import { Dispatch, SetStateAction } from 'react'
import { useSearchParams } from 'react-router'
import { useTheme } from '@mui/material'

import FullScreenDrawer from '../../../components/full-screen-drawer'

import useStyles from './index.styles'
import UserDetails from './user-details'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  user: IUserType
  selectedFolderId: number
}

const UserDetailsDrawer = (props: IProps) => {
  const { open, setOpen, user, selectedFolderId } = props

  const classes = useStyles
  const theme = useTheme()

  const [searchParams] = useSearchParams()

  return (
    <>
      <FullScreenDrawer
        open={open}
        title="Contact"
        showCloseIcon={false}
        showBackIcon={true}
        onClose={() => {
          setOpen(false)
          searchParams.set('action', '')
        }}
        modalPaperStyle={classes.userDetailsDrawer(theme)}
      >
        <UserDetails user={user} selectedFolderId={selectedFolderId} setOpen={setOpen} />
      </FullScreenDrawer>
    </>
  )
}

export default UserDetailsDrawer
